var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 29.229,
    viewBox: "0 0 26 29.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 26,
    height: 29.229,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M26,20.64V8.589a2.564,2.564,0,0,0-1.282-2.22L14.282.344a2.564,2.564,0,0,0-2.564,0L1.282,6.369A2.564,2.564,0,0,0,0,8.589V20.64a2.564,2.564,0,0,0,1.282,2.22l10.436,6.025a2.564,2.564,0,0,0,2.564,0L24.718,22.86A2.564,2.564,0,0,0,26,20.64",
    transform: "translate(0 0)",
    fill: "#8ebe78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M27.88,24.017V14.379a2.564,2.564,0,0,0-1.282-2.22L18.252,7.34a2.566,2.566,0,0,0-2.564,0L7.342,12.159a2.564,2.564,0,0,0-1.282,2.22v9.637a2.564,2.564,0,0,0,1.282,2.22l8.346,4.819a2.564,2.564,0,0,0,2.564,0L26.6,26.237a2.564,2.564,0,0,0,1.282-2.22",
    transform: "translate(-3.97 -4.583)",
    fill: "#d3fac0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "people_black_24dp",
    transform: "translate(4.09 5.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M0,0H17.82V17.82H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M12.138,9.455A2.228,2.228,0,1,0,9.91,7.228,2.218,2.218,0,0,0,12.138,9.455Zm-5.94,0A2.228,2.228,0,1,0,3.97,7.228,2.218,2.218,0,0,0,6.2,9.455Zm0,1.485c-1.73,0-5.2.869-5.2,2.6v1.114a.745.745,0,0,0,.743.743h8.91a.745.745,0,0,0,.743-.743V13.539C11.4,11.809,7.928,10.94,6.2,10.94Zm5.94,0c-.215,0-.46.015-.72.037.015.007.022.022.03.03a3.089,3.089,0,0,1,1.433,2.532v1.114a2.231,2.231,0,0,1-.134.743h3.846a.745.745,0,0,0,.743-.743V13.539C17.335,11.809,13.868,10.94,12.138,10.94Z",
    transform: "translate(-0.257 -1.287)",
    fill: "#8ebe78"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerActive);
export default __webpack_public_path__ + "static/media/customer-active.e44e9e2a44e4ed91cb7a17a6849e8254.svg";
export { ForwardRef as ReactComponent };